import { Card } from "../../ui/card";
import { Input } from "../../ui/input";
import { Label } from "../../ui/label";
import { Textarea } from "../../ui/textarea";

export const ContactContentForm = ({ content, update }) => (
  <Card className="p-6 space-y-4">
    <h3 className="font-semibold">Contacto</h3>
    <div>
      <Label>Ciudad base</Label>
      <Input data-testid="admin-content-contact-city" value={content.contact_city} onChange={(e) => update("contact_city", e.target.value)} className="mt-1" />
    </div>
    <div>
      <Label>Texto de cobertura</Label>
      <Textarea data-testid="admin-content-contact-note" value={content.contact_note} onChange={(e) => update("contact_note", e.target.value)} className="mt-1" />
    </div>
    <div>
      <Label>Número de WhatsApp (con código de país, sin +)</Label>
      <Input data-testid="admin-content-whatsapp-number" value={content.whatsapp_number} onChange={(e) => update("whatsapp_number", e.target.value)} className="mt-1" />
    </div>
  </Card>
);
